import React, { useEffect } from "react";
import cn from "classnames";

import frenemiesIcon from "src/assets/icons/frenemies.svg";
import crownIcon from "src/assets/icons/crown-contained.svg";

import { useStyles } from "./styles";
import { useLocale } from "../../../../providers/LocaleProvider";
import useStores from "../../../../hooks/useStores";

interface ITabProps {
    text: string;
    icon: string;
    isActive: boolean;
    onClick: () => void;
}

const Tab = ({ text, icon, isActive, onClick }: ITabProps) => {
    const classes = useStyles();
    return (
        <div
            className={cn(classes.tab, { [classes.tabActive]: isActive })}
            onClick={onClick}
        >
            <img src={icon} className={classes.frenemiesIcon} />
            <span
                className={cn(classes.tabText, {
                    [classes.tabTextActive]: isActive,
                })}
            >
                {text}
            </span>
        </div>
    );
};

interface IFriendsAndTopPlayersTabProps {
    value: "frenemies" | "topPlayers";
    onChange: (newValue: "frenemies" | "topPlayers") => void;
}

export const FriendsAndTopPlayersTab = ({
    value,
    onChange,
}: IFriendsAndTopPlayersTabProps) => {
    const classes = useStyles();

    const {
        lobby: {
            tabHeader: { rank, frenemies, soon },
        },
    } = useLocale();
    const { authStore } = useStores();
    const isAuthorized = authStore?.isAuthorized || false;

    useEffect(() => {
        if (!isAuthorized && value === 'frenemies') {
            onChange('topPlayers');
        }
    }, [isAuthorized]);


    return (
        <div className={classes.wrapper}>
            {isAuthorized && (
                <Tab
                    text={`${frenemies("Frenemies")}`}
                    icon={frenemiesIcon}
                    isActive={value === "frenemies"}
                    onClick={() => {
                        onChange("frenemies");
                    }}
                />
            )}
            <Tab
                text={rank("Rank")}
                icon={crownIcon}
                isActive={value === "topPlayers"}
                onClick={() => {
                    onChange("topPlayers");
                }}
            />
        </div>
    );
};